export const splitProp = (prop: string = ''): string[] =>
  prop.split(' ').filter((part) => part !== '');
